import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  button: {
    display: 'flex',
    color: '#159B78',
    fontSize: '18px',
    cursor: 'pointer'
  }
}));
